import React, { useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'
import BooksDetails from '../Components/Books/BooksDetails'
import ShopDetail from '../Components/Shop/ShopDetail'
import CookiePolicy from '../Components/StaticsPages/CookiePolicy'
import PrivacyPolicy from '../Components/StaticsPages/PrivacyPolicy'
import TermsAndCondition from '../Components/StaticsPages/TermsAndCondition'
import AboutUs from '../Pages/AboutUSScreen'
import CreateNewPasswod from '../Pages/AuthScreen/CreateNewPassword'
import ForgotPassword from '../Pages/AuthScreen/ForgotPassword'
import Login from '../Pages/AuthScreen/Login'
import OTP from '../Pages/AuthScreen/OTP'
import SignUp from '../Pages/AuthScreen/SignUp'
import Books from '../Pages/BooksScreen'
import Cart from '../Pages/CartScreen'
import Checkout from '../Pages/CheckoutScreen'
import ContactUs from '../Pages/ContactUsScreen'
import Home from '../Pages/HomeScreen/index'
import Layout from '../Pages/Layout'
import MyProfile from '../Pages/MyProfileScreen'
import Shop from '../Pages/ShopScreen'
import Subscription from '../Pages/SubscriptionScreen'
import SubscriptionCheckout from '../Pages/SubscriptionScreen/SubscriptionCheckout'
import ThankYou from '../Pages/ThankYou'
import ScrollToTop from '../Hooks/WebPages/ScrollToTop'

const WebRoutes = () => {


    return (
        <BrowserRouter>
            <ScrollToTop />
            <Routes>

                <Route path="/" element={<Layout />}>
                    <Route index element={<Home />} />
                    <Route path='/about-us' element={<AboutUs />} />
                    <Route path='/contact-us' element={<ContactUs />} />
                    <Route path='/books' element={<Books />} />
                    <Route path='/book-detail' element={<BooksDetails />} />
                    <Route path='/shop' element={<Shop />} />
                    <Route path='/product-detail/:slug' element={<ShopDetail />} />
                    <Route path='/my-cart' element={<Cart />} />
                    <Route path='/checkout' element={<Checkout />} />
                    <Route path='/thank-you' element={<ThankYou />} />
                    <Route path='/cookie-policy' element={<CookiePolicy />} />
                    <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                    <Route path='/terms-and-condition' element={<TermsAndCondition />} />
                    <Route path='/subscription' element={<Subscription />} />
                    <Route path='/subscription-checkout' element={<SubscriptionCheckout />} />
                    <Route path='/my-profile' element={<MyProfile />} />
                    <Route path='/login' element={<Login />} />
                    <Route path='/sign-up' element={<SignUp />} />
                    <Route path='/forgot-password' element={<ForgotPassword />} />
                    <Route path='/otp' element={<OTP />} />
                    <Route path='/create-new-password' element={<CreateNewPasswod />} />
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default WebRoutes